import { render, staticRenderFns } from "./category-child.vue?vue&type=template&id=33e09e3c&scoped=true"
import script from "./category-child.vue?vue&type=script&lang=ts"
export * from "./category-child.vue?vue&type=script&lang=ts"
import style0 from "./category-child.vue?vue&type=style&index=0&id=33e09e3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e09e3c",
  null
  
)

export default component.exports